import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getOwnerSelfStakeAmount } from 'modules/ownerPanel/methods/getOwnerSelfStakeAmount';

interface IGetOwnerSelfStakeAmountArgs {
  poolAddress: Address;
}

export const {
  useGetOwnerSelfStakeAmountQuery,
  endpoints: { getOwnerSelfStakeAmount: getSelfStakedAmountEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getOwnerSelfStakeAmount: build.query<
      BigNumber,
      IGetOwnerSelfStakeAmountArgs
    >({
      queryFn: async ({ poolAddress }) => {
        return {
          data: await getOwnerSelfStakeAmount(poolAddress),
        };
      },
      providesTags: [cacheTags.pools],
    }),
  }),
});
